module.exports = __webpack_public_path__ + "b5838c0bf2fd2114dac1bd4ec4abc860.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/nachos-s.png
// module id = 2688
// module chunks = 0